import React from 'react';
import * as Ons from 'react-onsenui';
import { translate as _ } from '../../util/i18n';

class ColorSelect extends React.Component {

    #colors;
    #mainColors;
    #secondaryColors;

    constructor( props ) {

        super( props );

        this.#mainColors = [

            { value: '#F8F8F8', label: _( 'weiß'    ) },
            { value: '#000000', label: _( 'schwarz' ) },
            { value: '#FF0000', label: _( 'rot'     ) },
            { value: '#00BFFF', label: _( 'blau'    ) },
            { value: '#FFFF00', label: _( 'gelb'    ) },
            { value: '#EE82EE', label: _( 'violett' ) }

        ];

        this.#secondaryColors = [

            { value: '#FFD700', label: _( 'gold'    ) },
            { value: '#D3D3D3', label: _( 'grau'    ) },
            { value: '#32CD32', label: _( 'grün'    ) },
            { value: '#FFA500', label: _( 'orange'  ) },
            { value: '#005F6A', label: _( 'petrol'  ) },
            { value: '#FFB6C1', label: _( 'pink'    ) },
            { value: '#C0C0C0', label: _( 'silber'  ) }

        ];

        this.#secondaryColors.sort( ( a, b ) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0 );

        this.#colors = this.#mainColors.concat( this.#secondaryColors );

    }

    render() {

        return (

            <Ons.Select {...this.props}>

                {this.#colors.map( e => <option value={e.value} key={e.value}>{e.label}</option> )}

            </Ons.Select>

        );

    }

}

export default ColorSelect;